import React from 'react'
import ChaiseImage from '../../../../assets/products/chaise-rectangle-3-breaks.webp'

const RoundedRectangleTwoBreaks = ({ totalWidth = '', totalChaiseLength = '' }) => {
  return (
    <svg width="762" height="498" viewBox="0 0 820 200" xmlns="http://www.w3.org/2000/svg">
      <image x="-250" y="-300" width="1080" height="760" xlinkHref={ChaiseImage} />
      {totalWidth && (
        <text x="381" y="70" fontSize="14" fill="#FFFFFF99">
          {totalWidth}
        </text>
      )}
      {totalChaiseLength && (
        <text x="300" y="-110" fontSize="14" fill="#FFFFFF99">
          Total length: {totalChaiseLength}
        </text>
      )}
      <g id="Group 1473">
        <g id="F-Comp">
          <g filter="url(#filter0_d_5406_8376)">
            <rect
              id="F-Background"
              x="24.252"
              y="102.399"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-21.414 24.252 102.399)"
              fill="transparent"
            />
            <path
              id="F-Text"
              d="M49.7987 107.678L49.5197 120.472L46.8836 120.415L47.1627 107.621L49.7987 107.678ZM54.776 113.255L54.7311 115.311L48.9141 115.184L48.959 113.128L54.776 113.255ZM55.5103 107.803L55.4652 109.868L49.0332 109.727L49.0782 107.663L55.5103 107.803Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="F-Line"
            d="M59.2655 34.5901C59.0124 34.4796 58.7177 34.5952 58.6072 34.8483L56.8066 38.9724C56.6961 39.2254 56.8117 39.5202 57.0648 39.6306C57.3179 39.7411 57.6126 39.6255 57.7231 39.3725L59.3236 35.7066L62.9894 37.3071C63.2425 37.4176 63.5372 37.302 63.6477 37.049C63.7582 36.7959 63.6426 36.5012 63.3896 36.3907L59.2655 34.5901ZM110.338 166.755C110.591 166.865 110.886 166.75 110.996 166.497L112.797 162.373C112.907 162.119 112.792 161.825 112.539 161.714C112.286 161.604 111.991 161.719 111.88 161.972L110.28 165.638L106.614 164.038C106.361 163.927 106.066 164.043 105.956 164.296C105.845 164.549 105.961 164.844 106.214 164.954L110.338 166.755ZM58.5999 35.2309L59.5191 37.5746L60.4501 37.2095L59.5309 34.8658L58.5999 35.2309ZM61.3574 42.262L63.1957 46.9495L64.1267 46.5844L62.2884 41.8969L61.3574 42.262ZM65.034 51.6369L66.8723 56.3244L67.8033 55.9593L65.965 51.2718L65.034 51.6369ZM68.7107 61.0118L70.549 65.6992L71.4799 65.3341L69.6416 60.6467L68.7107 61.0118ZM72.3873 70.3867L74.2256 75.0741L75.1566 74.709L73.3182 70.0216L72.3873 70.3867ZM76.0639 79.7615L77.9022 84.449L78.8332 84.0839L76.9949 79.3964L76.0639 79.7615ZM79.7405 89.1364L81.5788 93.8239L82.5098 93.4588L80.6715 88.7713L79.7405 89.1364ZM83.4171 98.5113L85.2554 103.199L86.1864 102.834L84.3481 98.1462L83.4171 98.5113ZM87.0938 107.886L88.9321 112.574L89.863 112.208L88.0247 107.521L87.0938 107.886ZM90.7704 117.261L92.6087 121.948L93.5397 121.583L91.7013 116.896L90.7704 117.261ZM94.447 126.636L96.2853 131.323L97.2163 130.958L95.378 126.271L94.447 126.636ZM98.1236 136.011L99.9619 140.698L100.893 140.333L99.0546 135.646L98.1236 136.011ZM101.8 145.386L103.639 150.073L104.57 149.708L102.731 145.021L101.8 145.386ZM105.477 154.76L107.315 159.448L108.246 159.083L106.408 154.395L105.477 154.76ZM109.153 164.135L110.073 166.479L111.004 166.114L110.084 163.77L109.153 164.135Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="D-Comp">
          <g filter="url(#filter1_d_5406_8376)">
            <rect
              id="D-Background"
              x="381.197"
              y="201.573"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-100.554 381.197 201.573)"
              fill="transparent"
            />
            <path
              id="D-Text"
              d="M396.751 184.158L393.965 184.131L394.003 182.075L396.771 182.101C397.462 182.108 398.047 181.958 398.524 181.652C399.002 181.34 399.364 180.883 399.61 180.282C399.861 179.681 399.991 178.953 400 178.097L400.005 177.473C400.012 176.817 399.947 176.239 399.811 175.74C399.681 175.241 399.483 174.82 399.216 174.477C398.95 174.135 398.621 173.877 398.231 173.703C397.84 173.524 397.389 173.432 396.88 173.427L394.014 173.4L394.034 171.334L396.899 171.362C397.755 171.37 398.535 171.524 399.242 171.823C399.954 172.117 400.568 172.536 401.084 173.08C401.601 173.624 401.996 174.272 402.27 175.025C402.55 175.772 402.686 176.602 402.677 177.516L402.671 178.123C402.663 179.031 402.511 179.858 402.217 180.606C401.929 181.353 401.521 181.994 400.995 182.528C400.474 183.056 399.852 183.463 399.129 183.749C398.411 184.03 397.619 184.166 396.751 184.158ZM395.581 171.349L395.46 184.145L392.823 184.12L392.944 171.324L395.581 171.349Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="D-Line"
            d="M315.97 155.386C315.814 155.613 315.872 155.925 316.1 156.081L319.811 158.626C320.039 158.782 320.35 158.724 320.506 158.497C320.662 158.269 320.604 157.958 320.377 157.801L317.078 155.539L319.34 152.24C319.497 152.013 319.439 151.701 319.211 151.545C318.983 151.389 318.672 151.447 318.516 151.675L315.97 155.386ZM465.85 128.18C466.007 127.952 465.949 127.641 465.721 127.484L462.01 124.939C461.782 124.783 461.471 124.841 461.315 125.069C461.158 125.296 461.216 125.608 461.444 125.764L464.743 128.026L462.48 131.325C462.324 131.553 462.382 131.864 462.61 132.02C462.838 132.176 463.149 132.118 463.305 131.891L465.85 128.18ZM316.474 156.16L318.959 155.697L318.775 154.714L316.291 155.177L316.474 156.16ZM323.927 154.771L328.896 153.846L328.712 152.863L323.744 153.788L323.927 154.771ZM333.864 152.92L338.833 151.994L338.65 151.011L333.681 151.937L333.864 152.92ZM343.801 151.069L348.77 150.143L348.587 149.16L343.618 150.085L343.801 151.069ZM353.738 149.217L358.707 148.291L358.524 147.308L353.555 148.234L353.738 149.217ZM363.675 147.366L368.644 146.44L368.461 145.457L363.492 146.383L363.675 147.366ZM373.612 145.514L378.581 144.588L378.398 143.605L373.429 144.531L373.612 145.514ZM383.549 143.663L388.518 142.737L388.335 141.754L383.366 142.68L383.549 143.663ZM393.486 141.811L398.455 140.886L398.272 139.902L393.303 140.828L393.486 141.811ZM403.423 139.96L408.392 139.034L408.209 138.051L403.24 138.977L403.423 139.96ZM413.36 138.108L418.329 137.183L418.146 136.2L413.177 137.125L413.36 138.108ZM423.297 136.257L428.266 135.331L428.083 134.348L423.114 135.274L423.297 136.257ZM433.234 134.405L438.203 133.48L438.02 132.497L433.051 133.422L433.234 134.405ZM443.171 132.554L448.14 131.628L447.957 130.645L442.988 131.571L443.171 132.554ZM453.108 130.703L458.077 129.777L457.894 128.794L452.925 129.72L453.108 130.703ZM463.045 128.851L465.53 128.388L465.346 127.405L462.862 127.868L463.045 128.851Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="E-Comp">
          <g filter="url(#filter2_d_5406_8376)">
            <rect
              id="E-Background"
              x="224.505"
              y="230.562"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-100.554 224.505 230.562)"
              fill="transparent"
            />
            <path
              id="E-Text"
              d="M245.528 211.141L245.508 213.198L238.697 213.133L238.716 211.077L245.528 211.141ZM239.679 200.345L239.558 213.142L236.922 213.117L237.043 200.32L239.679 200.345ZM244.692 205.605L244.673 207.609L238.75 207.553L238.769 205.549L244.692 205.605ZM245.621 200.402L245.601 202.467L238.799 202.402L238.818 200.337L245.621 200.402Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="E-Line"
            d="M157.933 184.625C157.777 184.853 157.835 185.164 158.063 185.32L161.774 187.865C162.002 188.022 162.313 187.964 162.469 187.736C162.625 187.508 162.567 187.197 162.339 187.041L159.041 184.778L161.303 181.48C161.46 181.252 161.402 180.941 161.174 180.784C160.946 180.628 160.635 180.686 160.479 180.914L157.933 184.625ZM310.501 156.918C310.657 156.69 310.599 156.379 310.372 156.223L306.661 153.678C306.433 153.521 306.122 153.579 305.965 153.807C305.809 154.035 305.867 154.346 306.095 154.502L309.394 156.765L307.131 160.063C306.975 160.291 307.033 160.602 307.261 160.759C307.488 160.915 307.8 160.857 307.956 160.629L310.501 156.918ZM158.437 185.399L160.966 184.928L160.783 183.945L158.254 184.416L158.437 185.399ZM166.024 183.986L171.083 183.043L170.899 182.06L165.841 183.003L166.024 183.986ZM176.141 182.101L181.199 181.158L181.016 180.175L175.957 181.118L176.141 182.101ZM186.257 180.216L191.315 179.274L191.132 178.29L186.074 179.233L186.257 180.216ZM196.373 178.331L201.431 177.389L201.248 176.406L196.19 177.348L196.373 178.331ZM206.489 176.446L211.547 175.504L211.364 174.521L206.306 175.463L206.489 176.446ZM216.605 174.561L221.664 173.619L221.48 172.636L216.422 173.578L216.605 174.561ZM226.722 172.677L231.78 171.734L231.597 170.751L226.539 171.694L226.722 172.677ZM236.838 170.792L241.896 169.849L241.713 168.866L236.655 169.809L236.838 170.792ZM246.954 168.907L252.012 167.965L251.829 166.981L246.771 167.924L246.954 168.907ZM257.07 167.022L262.128 166.08L261.945 165.097L256.887 166.039L257.07 167.022ZM267.186 165.137L272.245 164.195L272.061 163.212L267.003 164.154L267.186 165.137ZM277.303 163.252L282.361 162.31L282.178 161.327L277.12 162.269L277.303 163.252ZM287.419 161.368L292.477 160.425L292.294 159.442L287.236 160.385L287.419 161.368ZM297.535 159.483L302.593 158.54L302.41 157.557L297.352 158.5L297.535 159.483ZM307.651 157.598L310.18 157.127L309.997 156.144L307.468 156.615L307.651 157.598Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="C-Comp">
          <g filter="url(#filter3_d_5406_8376)">
            <rect
              id="C-Background"
              x="497.201"
              y="180.854"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-100.554 497.201 180.854)"
              fill="transparent"
            />
            <path
              id="C-Text"
              d="M516.25 159.226L518.877 159.251C518.816 160.111 518.572 160.874 518.144 161.538C517.721 162.202 517.134 162.718 516.38 163.085C515.632 163.453 514.734 163.632 513.685 163.622C512.865 163.615 512.131 163.467 511.483 163.18C510.836 162.886 510.283 162.471 509.825 161.933C509.373 161.396 509.031 160.748 508.798 159.99C508.565 159.232 508.453 158.384 508.461 157.447L508.47 156.559C508.479 155.622 508.61 154.776 508.863 154.023C509.122 153.263 509.486 152.619 509.954 152.09C510.427 151.562 510.991 151.157 511.644 150.876C512.297 150.595 513.025 150.458 513.828 150.466C514.894 150.476 515.792 150.678 516.52 151.072C517.255 151.465 517.821 152.004 518.219 152.687C518.623 153.371 518.861 154.147 518.935 155.015L516.299 154.99C516.274 154.474 516.176 154.036 516.003 153.677C515.831 153.312 515.567 153.037 515.211 152.852C514.862 152.661 514.394 152.563 513.808 152.558C513.368 152.554 512.984 152.632 512.654 152.793C512.324 152.954 512.047 153.2 511.821 153.532C511.595 153.864 511.424 154.284 511.308 154.793C511.198 155.296 511.139 155.887 511.133 156.567L511.124 157.472C511.118 158.134 511.162 158.717 511.257 159.222C511.352 159.721 511.5 160.145 511.702 160.492C511.91 160.834 512.177 161.094 512.503 161.273C512.836 161.446 513.236 161.535 513.705 161.54C514.256 161.545 514.711 161.461 515.07 161.289C515.429 161.116 515.704 160.858 515.895 160.514C516.091 160.17 516.21 159.741 516.25 159.226Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="C-Line"
            d="M473.635 126.904C473.478 127.131 473.536 127.443 473.764 127.599L477.475 130.144C477.703 130.3 478.014 130.242 478.17 130.015C478.326 129.787 478.268 129.476 478.041 129.32L474.742 127.057L477.005 123.758C477.161 123.531 477.103 123.219 476.875 123.063C476.647 122.907 476.336 122.965 476.18 123.193L473.635 126.904ZM540.193 115.222C540.349 114.994 540.291 114.683 540.063 114.527L536.352 111.982C536.124 111.825 535.813 111.883 535.657 112.111C535.501 112.339 535.559 112.65 535.787 112.806L539.085 115.069L536.823 118.367C536.666 118.595 536.724 118.906 536.952 119.062C537.18 119.219 537.491 119.161 537.647 118.933L540.193 115.222ZM474.138 127.678L476.486 127.241L476.303 126.258L473.955 126.695L474.138 127.678ZM481.181 126.366L485.877 125.491L485.693 124.508L480.998 125.383L481.181 126.366ZM490.572 124.616L495.267 123.741L495.084 122.758L490.389 123.633L490.572 124.616ZM499.962 122.867L504.658 121.992L504.474 121.009L499.779 121.884L499.962 122.867ZM509.353 121.117L514.048 120.242L513.865 119.259L509.17 120.134L509.353 121.117ZM518.743 119.367L523.439 118.493L523.255 117.509L518.56 118.384L518.743 119.367ZM528.134 117.618L532.829 116.743L532.646 115.76L527.951 116.635L528.134 117.618ZM537.524 115.868L539.872 115.431L539.689 114.448L537.341 114.885L537.524 115.868Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="B-Comp">
          <g filter="url(#filter4_d_5406_8376)">
            <rect
              id="B-Background"
              x="606.633"
              y="160.48"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-100.554 606.633 160.48)"
              fill="transparent"
            />
            <path
              id="B-Text"
              d="M623.427 137.459L620.14 137.428L620.139 135.618L622.899 135.644C623.385 135.648 623.784 135.591 624.096 135.47C624.408 135.345 624.641 135.162 624.796 134.923C624.956 134.679 625.038 134.381 625.041 134.029C625.045 133.631 624.972 133.308 624.822 133.06C624.678 132.813 624.448 132.632 624.133 132.518C623.823 132.403 623.422 132.344 622.93 132.339L621.102 132.322L621.001 143.053L618.364 143.028L618.485 130.232L622.95 130.274C623.694 130.281 624.358 130.358 624.943 130.504C625.533 130.65 626.032 130.869 626.44 131.159C626.847 131.45 627.157 131.817 627.37 132.258C627.582 132.694 627.686 133.21 627.68 133.808C627.675 134.335 627.551 134.821 627.306 135.264C627.068 135.707 626.692 136.066 626.18 136.343C625.673 136.619 625.012 136.768 624.198 136.79L623.427 137.459ZM623.259 143.074L619.366 143.037L620.414 140.991L623.279 141.018C623.742 141.022 624.12 140.952 624.415 140.809C624.709 140.659 624.928 140.456 625.071 140.2C625.214 139.943 625.287 139.648 625.29 139.314C625.294 138.939 625.232 138.613 625.106 138.337C624.986 138.06 624.788 137.847 624.514 137.698C624.24 137.543 623.878 137.464 623.427 137.459L620.887 137.435L620.922 135.625L624.085 135.655L624.685 136.373C625.465 136.368 626.09 136.512 626.562 136.803C627.04 137.089 627.385 137.459 627.597 137.912C627.816 138.365 627.923 138.85 627.918 139.365C627.91 140.186 627.725 140.875 627.362 141.434C626.999 141.988 626.471 142.402 625.777 142.676C625.089 142.951 624.249 143.084 623.259 143.074Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="B-Line"
            d="M547.433 113.169C547.277 113.397 547.335 113.708 547.563 113.864L551.274 116.41C551.502 116.566 551.813 116.508 551.969 116.28C552.125 116.053 552.067 115.741 551.839 115.585L548.541 113.323L550.803 110.024C550.96 109.796 550.902 109.485 550.674 109.329C550.446 109.173 550.135 109.231 549.979 109.458L547.433 113.169ZM685.258 88.2093C685.415 87.9815 685.357 87.6703 685.129 87.5141L681.418 84.9688C681.19 84.8126 680.879 84.8706 680.723 85.0983C680.567 85.326 680.625 85.6373 680.852 85.7935L684.151 88.056L681.889 91.3546C681.732 91.5823 681.79 91.8936 682.018 92.0498C682.246 92.206 682.557 92.148 682.713 91.9202L685.258 88.2093ZM547.937 113.944L550.384 113.488L550.201 112.505L547.754 112.961L547.937 113.944ZM555.277 112.576L560.169 111.665L559.986 110.682L555.093 111.593L555.277 112.576ZM565.062 110.753L569.955 109.841L569.772 108.858L564.879 109.77L565.062 110.753ZM574.848 108.93L579.741 108.018L579.558 107.035L574.665 107.947L574.848 108.93ZM584.634 107.106L589.527 106.195L589.344 105.212L584.451 106.123L584.634 107.106ZM594.42 105.283L599.312 104.372L599.129 103.388L594.236 104.3L594.42 105.283ZM604.205 103.46L609.098 102.548L608.915 101.565L604.022 102.477L604.205 103.46ZM613.991 101.637L618.884 100.725L618.701 99.7419L613.808 100.654L613.991 101.637ZM623.777 99.8134L628.67 98.9018L628.487 97.9187L623.594 98.8303L623.777 99.8134ZM633.563 97.9901L638.455 97.0785L638.272 96.0954L633.379 97.007L633.563 97.9901ZM643.348 96.1669L648.241 95.2552L648.058 94.2722L643.165 95.1838L643.348 96.1669ZM653.134 94.3436L658.027 93.432L657.844 92.4489L652.951 93.3605L653.134 94.3436ZM662.92 92.5203L667.813 91.6087L667.63 90.6256L662.737 91.5373L662.92 92.5203ZM672.706 90.6971L677.598 89.7854L677.415 88.8024L672.522 89.714L672.706 90.6971ZM682.491 88.8738L684.938 88.418L684.755 87.4349L682.308 87.8907L682.491 88.8738Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="A-Comp">
          <g filter="url(#filter5_d_5406_8376)">
            <rect
              id="A-Background"
              x="761.196"
              y="63.2329"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-174.18 761.196 63.2329)"
              fill="transparent"
            />
            <path
              id="A-Text"
              d="M743.18 36.6516L739.699 47.26H736.896L741.65 34.4631H743.435L743.18 36.6516ZM746.071 47.26L742.582 36.6516L742.301 34.4631H744.103L748.884 47.26H746.071ZM745.913 42.4963V44.5618H739.154V42.4963H745.913Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="A-Line"
            d="M703.751 61.2204C703.926 61.4345 704.24 61.4666 704.455 61.2921L707.943 58.4492C708.157 58.2748 708.189 57.9598 708.014 57.7457C707.84 57.5317 707.525 57.4996 707.311 57.674L704.21 60.2011L701.683 57.1004C701.509 56.8864 701.194 56.8543 700.98 57.0287C700.766 57.2032 700.734 57.5181 700.908 57.7322L703.751 61.2204ZM709.387 12.8969C709.213 12.6828 708.898 12.6507 708.684 12.8252L705.196 15.6681C704.982 15.8426 704.95 16.1575 705.124 16.3716C705.298 16.5856 705.613 16.6177 705.827 16.4433L708.928 13.9162L711.455 17.0169C711.63 17.231 711.945 17.2631 712.159 17.0886C712.373 16.9141 712.405 16.5992 712.23 16.3851L709.387 12.8969ZM704.636 60.9552L704.879 58.5707L703.884 58.4693L703.641 60.8538L704.636 60.9552ZM705.365 53.8015L705.851 49.0323L704.857 48.9309L704.37 53.7001L705.365 53.8015ZM706.338 44.2631L706.824 39.4939L705.829 39.3925L705.343 44.1617L706.338 44.2631ZM707.31 34.7248L707.796 29.9556L706.801 29.8542L706.315 34.6234L707.31 34.7248ZM708.282 25.1864L708.768 20.4172L707.773 20.3158L707.287 25.085L708.282 25.1864ZM709.254 15.6481L709.497 13.2635L708.502 13.1621L708.259 15.5467L709.254 15.6481Z"
            fill="#FFFFFF99"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_5406_8376"
          x="-5.74805"
          y="67.4294"
          width="113.139"
          height="113.139"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5406_8376" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5406_8376"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_5406_8376"
          x="343.688"
          y="133.757"
          width="107.816"
          height="107.816"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5406_8376" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5406_8376"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_5406_8376"
          x="186.995"
          y="162.746"
          width="107.816"
          height="107.816"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5406_8376" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5406_8376"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_5406_8376"
          x="459.691"
          y="113.037"
          width="107.816"
          height="107.816"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5406_8376" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5406_8376"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_5406_8376"
          x="569.123"
          y="92.6636"
          width="107.816"
          height="107.816"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5406_8376" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5406_8376"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_5406_8376"
          x="690.407"
          y="-1.71338"
          width="104.946"
          height="104.946"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5406_8376" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5406_8376"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default RoundedRectangleTwoBreaks
